import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const LegacySupportSection = ({ title, subtitle, copy }) => (
  <section id="support" className="px-6 py-16 md:py-20 bg-white/5 border-y border-white/10">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-[1fr_0.9fr] gap-10 items-center">
      <div className="space-y-4">
        <p className="text-sm uppercase tracking-[0.2em] text-cyan-200/80">{title}</p>
        <h2 className="text-3xl md:text-4xl font-semibold text-[#f8f5ed]">{subtitle}</h2>
        <p className="text-[#d8d2c5]">{copy}</p>
        <div className="flex gap-3">
          <Link
            to="/register"
            className="rounded-full bg-emerald-400 text-[#0f1115] px-5 py-3 font-semibold shadow-lg shadow-emerald-400/30 hover:translate-y-[-1px] transition"
          >
            Start onboarding
          </Link>
          <a
            href="mailto:support@grouphela.com"
            className="rounded-full border border-white/20 px-5 py-3 font-semibold text-[#f4efe6] hover:border-white/40 transition"
          >
            Email support
          </a>
        </div>
      </div>
      <div className="rounded-3xl border border-white/10 bg-white/5 p-6 shadow-2xl backdrop-blur">
        <div className="flex items-center justify-between text-sm text-[#d8d2c5]">
          <span>Service map</span>
          <span className="rounded-full bg-white/10 px-3 py-1 text-xs">Live</span>
        </div>
        <div className="mt-4 grid grid-cols-2 gap-4 text-sm">
          {[
            ['Chat + Email', '9am - 9pm EAT'],
            ['Onboarding', 'White-glove setup'],
            ['Templates', 'Minutes, reminders, exports'],
            ['Security', 'Audit + 2FA ready'],
          ].map(([cardTitle, meta]) => (
            <div key={cardTitle} className="rounded-2xl bg-[#11151b]/75 p-4 border border-white/5">
              <p className="text-[#f4efe6]">{cardTitle}</p>
              <p className="text-xs text-[#c7c0b2]">{meta}</p>
            </div>
          ))}
        </div>
        <p className="mt-4 text-xs text-[#d8d2c5]">
          Need something custom? We ship in your brand, your voice, and your governance style.
        </p>
      </div>
    </div>
  </section>
);

LegacySupportSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  copy: PropTypes.string,
};

LegacySupportSection.defaultProps = {
  title: '',
  subtitle: '',
  copy: '',
};

export default LegacySupportSection;
